import { render, staticRenderFns } from "./WordSearch.vue?vue&type=template&id=e920dc3c&scoped=true"
import script from "./WordSearch.vue?vue&type=script&lang=js"
export * from "./WordSearch.vue?vue&type=script&lang=js"
import style0 from "./WordSearch.vue?vue&type=style&index=0&id=e920dc3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e920dc3c",
  null
  
)

export default component.exports